import { Directive, Input } from '@angular/core';
import { FormControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';

@Directive({
  selector: '[matchOtherValidator][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MatchOtherValidator,
      multi: true
    }
  ]
})
export class MatchOtherValidator implements Validator {
  @Input('matchOtherValidator') otherControlName: any;

  validator: ValidatorFn;
  thisControl: FormControl;
  otherControl: FormControl;

  constructor() {
    this.validator = this.matchOtherValidator();
  }

  validate(control: FormControl): any {
    return this.validator(control);
  }

  matchOtherValidator(): ValidatorFn {
    return (control: FormControl) => {
      if (!control.parent) {
        return null;
      }

      // Initializing the validator.
      if (!this.thisControl) {
        console.log(this.otherControlName);
        console.log(control.parent);

        this.thisControl = control;
        this.otherControl = control.parent.get(this.otherControlName) as FormControl;
        if (!this.otherControl) {
          throw new Error('matchOtherValidator(): other control is not found in parent group');
        }
        this.otherControl.valueChanges.subscribe(() => {
          this.thisControl.updateValueAndValidity();
        });
      }

      if (!this.otherControl) {
        return null;
      }

      if (this.otherControl.value !== this.thisControl.value) {
        return {
          matchOther: true
        };
      }

      return null;
    };
  }
}
